<template>
  <form ref="formRef" novalidate @submit.prevent="saveEmergencia" class="d-flex align-items-center gap-4 fondo-terciario rounded-4 p-3 px-4 sombra-sm mb-4">
    <div class="card-body w-100">
      <div class="d-flex justify-content-between align-items-center mb-3 w-100">
        <h2 class="fw-bold fs-5 m-0 mt-1">{{ $t('contactoDeEmergencia') }}</h2>
        <button @click="isEditingEmergencia = true" v-if="(hasEditarPersonaPermission && !isEditingEmergencia) || isEditingPerfil" type="button" class="btn p-0 d-flex flex-row align-items-center justify-content-center tooltip-container border-0">
          <svg width="20" height="20" viewBox="0 0 24 24" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21 21H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="tooltip-text">{{ $t('editar') }}</span>
        </button>
      </div>
      <div class="mb-3 d-flex flex-column">
        <label class="m-0 texto-secundario fs-7">{{ $t('nombre') }}{{ isEditingEmergencia && isEditingPerfil ? '*' : '' }}</label>
        <p v-if="!isEditingEmergencia" class="m-0">{{ localPersona.NomContactoEmerg || 'N/A' }}</p>
        <input v-if="isEditingEmergencia" type="text" v-model="localPersona.NomContactoEmerg" class="form-control fondo-principal sombra-sm" :disabled="!isEditingEmergencia" maxlength="200" required />
        <div class="invalid-feedback">{{ $t('nombreRequerido') }}</div>
      </div>

      <div class="mb-3 d-flex flex-column">
        <label class="m-0 texto-secundario fs-7">{{ $t('telefonoCelular') }}{{ isEditingEmergencia && isEditingPerfil ? '*' : '' }}</label>
        <p v-if="!isEditingEmergencia" class="m-0">{{ telContactoEmerg || 'N/A' }}</p>
        <input v-if="isEditingEmergencia" type="number" v-model="telContactoEmerg" class="form-control fondo-principal sombra-sm" :disabled="!isEditingEmergencia" required />
        <div class="invalid-feedback">{{ $t('telefonoRequerido') }}</div>
      </div>

      <div class="d-flex flex-column">
        <label class="m-0 texto-secundario fs-7">{{ $t('vinculoRelacion') }}{{ isEditingEmergencia && isEditingPerfil ? '*' : '' }}</label>

        <p v-if="!isEditingEmergencia" class="m-0">{{ $t(localPersona.RelacionContactoEmerg ? localPersona.RelacionContactoEmerg : 'N/A') }}</p>

        <div v-if="isEditingEmergencia" class="select-wrapper">
          <select id="estadoCivil" v-model="localPersona.RelacionContactoEmerg" class="form-select fondo-principal sombra-sm" :disabled="!isEditingEmergencia" required >
            <option value="abuelo">{{ $t('abuelo') }}</option>
            <option value="amigo">{{ $t('amigo') }}</option>
            <option value="cuidador">{{ $t('cuidador') }}</option>
            <option value="familiar">{{ $t('familiar') }}</option>
            <option value="hijo">{{ $t('hijo') }}</option>
            <option value="nieto">{{ $t('nieto') }}</option>
            <option value="padreMadre">{{ $t('padreMadre') }}</option>
            <option value="pareja">{{ $t('pareja') }}</option>
            <option value="primo">{{ $t('primo') }}</option>
            <option value="sobrino">{{ $t('sobrino') }}</option>
            <option value="socio">{{ $t('socio') }}</option>
            <option value="tio">{{ $t('tio') }}</option>
            <option value="tutor">{{ $t('tutor') }}</option>
            <option value="vecino">{{ $t('vecino') }}</option>
          </select>
          <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
          </svg>
          <div class="invalid-feedback">{{ $t('relacionRequerida') }}</div>
        </div>
      </div>
      <div v-if="isEditingEmergencia" class="d-flex justify-content-end gap-2 mt-3">
        <button class="btn success-btn sombra-sm d-flex align-items-center gap-2" type="submit" :disabled="loadingEmergencia">
          {{ $t('guardarCambios') }}
          <img v-if="loadingEmergencia" src="@/assets/LOADING.gif" style="width: 20px;" alt="Cargando..." />
        </button>
        <button class="btn secondary-btn sombra-sm" type="button" @click="cancelEdit">{{ $t('cancelar') }}</button>
      </div>
    </div>
  </form>
</template>

<script>
import { ref, computed, watch, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import api from '@/services/api';

export default {
  name: 'ContactoEmergSection',
  props: {
    persona: {
      type: Object,
      required: true
    },
    hasEditarPersonaPermission: {
      type: Boolean,
      default: false
    },
    isEditingPerfil: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const isEditingEmergencia = ref(false);
    const loadingEmergencia = ref(false);
    const localPersona = ref({
      ...props.persona,
      Telefonos: [...(props.persona.Telefonos || [])]
    });
    const errors = ref({});
    const formRef = ref(null);

    const findOrCreateTelefono = (tipo) => {
      if (!localPersona.value.Telefonos) {
        localPersona.value.Telefonos = [];
      }
      let telefono = localPersona.value.Telefonos.find(t => t.Tipo === tipo);
      if (!telefono) {
        telefono = { Numero: '', Tipo: tipo };
        localPersona.value.Telefonos.push(telefono);
      }
      return telefono;
    };

    const telContactoEmerg = computed({
      get() {
        const tel = localPersona.value.Telefonos?.find(t => t.Tipo === 'Contacto de Emergencia');
        return tel ? tel.Numero : '';
      },
      set(newValue) {
        const telefono = findOrCreateTelefono('Contacto de Emergencia');
        telefono.Numero = String(newValue);
      }
    });

    const validateEmergencia = async () => {
      errors.value = {};
      let isValid = true;
      if(props.isEditingPerfil){
        if (!localPersona.value.NomContactoEmerg || localPersona.value.NomContactoEmerg.trim() === '') {
          errors.value.NomContactoEmerg = t('nombreRequerido');
          isValid = false;
        }
        if (!telContactoEmerg.value) {
          errors.value.telContactoEmerg = t('telefonoRequerido');
          isValid = false;
        }
        if (!localPersona.value.RelacionContactoEmerg) {
          errors.value.RelacionContactoEmerg = t('relacionRequerida');
          isValid = false;
        }
      }
      await nextTick();
      if (!isValid) {
        formRef.value?.classList.add('was-validated');
      } else {
        formRef.value?.classList.remove('was-validated');
      }
      return isValid;
    };

    const saveEmergencia = async () => {
      if (!(await validateEmergencia())) {
        return;
      }
      loadingEmergencia.value = true;
      try {
        // Buscamos el teléfono de emergencia en nuestro estado local
        const telEmergenciaObj = localPersona.value.Telefonos?.find(t => t.Tipo === 'Contacto de Emergencia');

        const telDto = (telEmergenciaObj && telEmergenciaObj.Numero)
            ? { Numero: telEmergenciaObj.Numero, Tipo: 'Contacto de Emergencia' }
            : null;

        const data = {
            nomContactoEmerg: localPersona.value.NomContactoEmerg,
            relacionContactoEmerg: localPersona.value.RelacionContactoEmerg,
            telContactoEmerg: telDto // <-- Enviamos el objeto o null
        };
        await api.put(`api/Persona/${props.persona.IdPersona}/contacto-emergencia`, data);
        isEditingEmergencia.value = false;
        emit('updated');
      } catch (error) {
        console.error('Error al guardar contacto de emergencia:', error);
        alert('Hubo un problema al guardar el contacto de emergencia.');
      } finally {
        loadingEmergencia.value = false;
      }
    };

    const cancelEdit = () => {
      localPersona.value = {
        ...props.persona,
        Telefonos: [...(props.persona.Telefonos || [])]
      };
      isEditingEmergencia.value = false;
    };

    watch(() => props.persona, (newPersona) => {
      localPersona.value = {
        ...newPersona,
        Telefonos: [...(newPersona.Telefonos || [])]
      };
    }, { immediate: true });

    return {
      t,
      isEditingEmergencia,
      loadingEmergencia,
      localPersona,
      telContactoEmerg,
      saveEmergencia,
      cancelEdit,
      validateEmergencia,
      errors,
      formRef,
    };
  },
};
</script>

<style>
</style>